import { render, staticRenderFns } from "./DemographicsChart.vue?vue&type=template&id=08605b36&scoped=true"
import script from "./DemographicsChart.vue?vue&type=script&lang=js"
export * from "./DemographicsChart.vue?vue&type=script&lang=js"
import style0 from "./DemographicsChart.vue?vue&type=style&index=0&id=08605b36&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08605b36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08605b36')) {
      api.createRecord('08605b36', component.options)
    } else {
      api.reload('08605b36', component.options)
    }
    module.hot.accept("./DemographicsChart.vue?vue&type=template&id=08605b36&scoped=true", function () {
      api.rerender('08605b36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/dashboardSolicitudes/components/DemographicsChart.vue"
export default component.exports